import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";

import { Spin, Table, Button } from "antd";

import { handleError } from "../../modules/presence/sagas";
import { roles } from "../../configs/constants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";
const reinitDimPoc = async token => {
  try {
    await axios.post(
      `${baseapi}/nextgen/initdimpoc`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    );
  } catch (e) {
    handleError(e);
  }
};
const insertPocInDim = async (pdc_id, token) => {
  try {
    await axios.post(
      `${baseapi}/nextgen/insertpocindim`,
      { pdc_id },
      {
        headers: {
          Authorization: token
        }
      }
    );
  } catch (e) {
    handleError(e);
  }
};
const NextGenDimPoc = ({ token, userRoleId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchMissingPocs = async () => {
    setIsLoading(true);
    try {
      const result = await axios.get(`${baseapi}/nextgen/missingpocs`, {
        headers: {
          Authorization: token
        }
      });
      setData(result.data);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchMissingPocs();
  }, []);
  const columns = [
    {
      title: "Id",
      key: "pdc_id",
      render: text => {
        return <div>{text.pdc_id}</div>;
      }
    },
    {
      title: "Label",
      key: "pdc_label",
      render: text => {
        return <div>{text.pdc_label}</div>;
      }
    },

    {
      title: "Actions",
      key: "actions",

      render: record => {
        return (
          <div style={{ height: 36, paddingTop: 11 }}>
            <div
              className={`cursor-pointer underline text-orange-400 pr-10 mt-5`}
              onClick={async () => {
                setIsLoading(true);
                await insertPocInDim(record.pdc_id, token);
                await fetchMissingPocs();
                setIsLoading(false);
              }}
            >
              Insérer le pdc dans la dimension dim poc
            </div>
          </div>
        );
      }
    }
  ];
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30 }}>{`Liste des pocs manquants`}</div>
        </div>
        {userRoleId === roles.ADMIN && (
          <Button
            disabled={isLoading}
            className="p-content-page-center-header-buttons-item"
            style={{ background: "#52c41a" }}
            onClick={async () => {
              setIsLoading(true);
              await reinitDimPoc(token);
              await fetchMissingPocs();
              setIsLoading(false);
            }}
          >
            Réinitialiser la collection dim poc
          </Button>
        )}
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
      </React.Fragment>
    </Container>
  );
};

export default NextGenDimPoc;



// WEBPACK FOOTER //
// src/pages/NextGenDashboard/NextGenDimPoc.js